/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react'
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';

import sessionSelectors from 'redux/reduxStore/session';
import profileSelectors from 'redux/reduxStore/profile';
import userSelectors from 'redux/reduxStore/user';

import sessionActions from 'redux/actions/session';
import navigationActions from 'redux/actions/navigation';

import { ImageButton } from 'components/common/Button';
import Text from 'components/common/Text';
import CircleX from '../../../images/CircleX';

import './ProfileMenuPopup.css';

import routeNames from 'lib/routeNames';
import ProfileModel from 'models/ProfileModel';

function mapStateToProps(state) {
  const profileId = userSelectors.getMainProfileId(state);
  const profile = profileSelectors.get(state, profileId);

  return {
    fullName: ProfileModel.fullName(profile),
  };
};

function mapDispatchToProps(dispatch) {
  return {
    logout: () => {
      dispatch(sessionActions.logout());
      dispatch(navigationActions.goTo(routeNames.loginEmail()));
    },
    goToProfile: () => {
      dispatch(navigationActions.goTo(routeNames.myProfileInfo()));
    },
  };
};

const ProfileMenuPopup = (props) => (
  <div className="cmp-profilemenupopup" onClick={(e) => { e.stopPropagation(); }}>
    <button onClick={props.onClose}>
      <CircleX />
    </button>

    <ul>
      <li onClick={props.goToProfile}>
        <div className="cmp-profilemenupopup-title">
          <FormattedMessage id="profile.title.text" />
        </div>

        <div className="title">
          {props.fullName}
        </div>
      </li>
      <li onClick={props.logout}>
        <FormattedMessage id="nav.logout.button.label" />
      </li>
    </ul>

  </div>
)

export default connect(mapStateToProps, mapDispatchToProps)(ProfileMenuPopup);
